module.exports = __webpack_public_path__ + "static/media/sound_10.d9d55e41.mp3";